import { render, staticRenderFns } from "./PersonalLoanTable.vue?vue&type=template&id=43d18716"
import script from "./PersonalLoanTable.vue?vue&type=script&lang=js"
export * from "./PersonalLoanTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports